import index from "./tuvzuvlul.vue";
export default index;
